import { createAction, props } from '@ngrx/store';

const GET_SCREENS_INTERIM = '[ScreenInterim] Get ScreenInterim';
const SET_SCREENS_INTERIM = '[ScreenInterim] Set Screens Interim';
const GET_SCREEN_STRUCTURE_INTERIM = '[ScreenInterim] Get Screen Structure Interim';
const SET_SCREEN_STRUCTURE_INTERIM = '[ScreenInterim] Set Screen Structure Interim';
const UPDATE_SCREEN_STRUCTURE_INTERIM = '[ScreenInterim] Update Screen Structure Interim';
const UPDATE_SCREEN_CONFIG_INTERIM = '[ScreenInterim] Config fields And file Content Update Interim';
const SAVE_CONF_FLCNT_SUCCESS_INTERIM = '[ScreenInterim] Config fields saved Interim';
const SAVE_CONF_FLCNT_FAILURE_INTERIM = '[ScreenInterim] Config fields save Failed Interim';
const DELETE_SCREEN_INTERIM = '[ScreenInterim] Delete Screen Interim';
const CURRENT_DELETE_SCREEN_INTERIM = '[ScreenInterim] Current Delete Screen Interim';
const DELETE_SCREEN_INTERIM_FAILURE = '[ScreenInterim] Delete Screen Interim Failure';
const CLEAR_SCREENS_INTERIM = '[ScreenInterim] Clear Screens Interim';

const getScreensInterim = createAction(
  GET_SCREENS_INTERIM,
  props<{
    getScreensInterimApiConstants: any;
    payloadWithPathVariables: {
      generationId: string;
      start: number;
      length: number;
      order: any[];
      removeUrlVariables: string[];
    };
  }>()
);

const setScreensInterim = createAction(SET_SCREENS_INTERIM, props<{ screensInterim: any }>());

const getScreenStructureInterim = createAction(
  GET_SCREEN_STRUCTURE_INTERIM,
  props<{ getScreenStructureInterimApiConstants: any; sid: any }>()
);

const setScreenStructureInterim = createAction(SET_SCREEN_STRUCTURE_INTERIM, props<{ screenStructureInterim: any }>());

const updateScreenStructureInterim = createAction(
  UPDATE_SCREEN_STRUCTURE_INTERIM,
  props<{ updateStructureInterimApiConstants: any; updatedStructure: any }>()
);

const updateScnAndDMConfigInterim = createAction(
  UPDATE_SCREEN_CONFIG_INTERIM,
  props<{ updateApiCons: any; updatedData: any }>()
);

const saveConfFlCntSuccessInterim = createAction(SAVE_CONF_FLCNT_SUCCESS_INTERIM, props<{ results: any }>());

const saveConfFlCntFailureInterim = createAction(SAVE_CONF_FLCNT_FAILURE_INTERIM, props<{ error: any }>());

const deleteScreenInterim = createAction(DELETE_SCREEN_INTERIM, props<{ deleteScreenInterimApi: any; screenId: any }>());

const currentDeleteScreenInterim = createAction(CURRENT_DELETE_SCREEN_INTERIM, props<{ deletedScreenInterimId: string }>());

const deleteScreenInterimFailure = createAction(DELETE_SCREEN_INTERIM_FAILURE, props<{ screenId: any; error: any }>());

const clearScreensInterim = createAction(CLEAR_SCREENS_INTERIM);

const ScreenInterimActions = {
  getScreensInterim,
  setScreensInterim,
  getScreenStructureInterim,
  setScreenStructureInterim,
  updateScreenStructureInterim,
  updateScnAndDMConfigInterim,
  saveConfFlCntSuccessInterim,
  saveConfFlCntFailureInterim,
  deleteScreenInterim,
  currentDeleteScreenInterim,
  deleteScreenInterimFailure,
  clearScreensInterim
};
export default ScreenInterimActions;
